import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useDeliveryIntervalOptions, getInitialSolutionsState, solutionsEcommReducer, getSolutionsEcommActions } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

const SolutionsEcommContext = /*#__PURE__*/ React.createContext({});
const useSolutionsEcommContext = ()=>React.useContext(SolutionsEcommContext)
;
/**
 * @deprecated use the new `SolutionsEcommProvider` in fun-products instead
 */ const SolutionsEcommProvider = ({ children  })=>{
    const { activeVariant , deliveryIntervalOptionsFallback  } = useProductDetailContext();
    const { singleDeliveryIntervalOption  } = useDeliveryIntervalOptions({
        deliveryInterval: null,
        deliveryIntervalOptionsFallback,
        availableSubscriptionIntervals: undefined
    });
    const initialState = React.useMemo(()=>{
        return getInitialSolutionsState(singleDeliveryIntervalOption === null || singleDeliveryIntervalOption === void 0 ? void 0 : singleDeliveryIntervalOption.value);
    }, []);
    const [state, dispatch] = React.useReducer(solutionsEcommReducer, initialState);
    const actions = React.useMemo(()=>getSolutionsEcommActions(dispatch)
    , []);
    const value = React.useMemo(()=>({
            actions,
            state
        })
    , [
        actions,
        state
    ]);
    if (!CommerceToolsApi.isSolutions(activeVariant)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SolutionsEcommContext.Provider, {
        value: value
    }, children);
};

export { SolutionsEcommContext, SolutionsEcommProvider, useSolutionsEcommContext };
//# sourceMappingURL=SolutionsEcommContext.js.map
